import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { fetchWebAdvertisement } from "../../store/admin-cms-actions";
import SingleCommercial from "./SingleCommercial/SingleCommercial";
import styles from "./Commercials.module.scss";
import Button from "../UI/Buttons/Button/Button";
import NewCommercial from "./NewCommercial/NewCommercial";
import NotificationMessage from "../UI/NotificationMessage/NotificationMessage";
import AppBrandSelector from "../shared/AppBrandSelector/AppBrandSelector";
import { AppBrand } from "../../types/appBrand";

const WebCommercials = () => {
  const dispatch = useDispatch();
  const createNewAdvertisementSuccess = useSelector(
    (state: RootState) => state.adminCMS.createNewAdvertisementSuccess
  );
  const updateAdvertisementSuccess = useSelector(
    (state: RootState) => state.adminCMS.updateAdvertisementSuccess
  );

  const webCommercials = useSelector(
    (state: RootState) => state.adminCMS.webAdvertisements
  );
  const loadingWebCommercials = useSelector(
    (state: RootState) => state.adminCMS.fetchWebAdvertisementsStart
  );

  const [selectedAppBrand, setSelectedAppBrand] = useState<AppBrand | null>(
    null
  );
  const [newAdvModalVisible, setNewAdvModalVisible] = useState(false);
  const [notificationMessageVisible, setNotificationMessageVisible] =
    useState(false);
  const [
    updateNotificationMessageVisible,
    setUpdateNotificationMessageVisible,
  ] = useState(false);

  // Fetch advertisements when component mounts or App Brand changes
  useEffect(() => {
    if (selectedAppBrand) {
      dispatch<any>(fetchWebAdvertisement(selectedAppBrand.id));
    }
  }, [selectedAppBrand, dispatch]);

  useEffect(() => {
    if (updateAdvertisementSuccess) {
      setUpdateNotificationMessageVisible(true);
      setTimeout(() => {
        setUpdateNotificationMessageVisible(false);
      }, 5000);
    }
  }, [updateAdvertisementSuccess]);

  useEffect(() => {
    if (createNewAdvertisementSuccess) {
      setNotificationMessageVisible(true);
      setTimeout(() => {
        setNotificationMessageVisible(false);
      }, 5000);
    }
  }, [createNewAdvertisementSuccess]);

  const createNewCommercial = () => {
    setNewAdvModalVisible(true);
  };

  const closeNewCommercialModal = () => {
    setNewAdvModalVisible(false);
  };

  const handleAppBrandChange = useCallback((brand: AppBrand) => {
    setSelectedAppBrand(brand);
  }, []);

  return (
    <>
      <div className={styles.CommercialPageHeader}>
        <div className={styles.HeaderTop}>
          <span style={{ fontSize: "24px" }}>Podešavanje reklama za web</span>
          <Button
            buttonType="blue"
            style={{ width: "200px" }}
            onClick={createNewCommercial}
          >
            Dodaj reklamu
          </Button>
        </div>
        <AppBrandSelector
          onBrandChange={handleAppBrandChange}
          restrictToApotekaRS={true}
          className={styles.AppBrandSelector}
        />
      </div>
      <div className={styles.CommercialImages}>
        {/* Show advertisements if they exist */}
        {webCommercials.length > 0 &&
          !loadingWebCommercials &&
          webCommercials.map((commercial: any, index: number) => {
            return (
              <SingleCommercial
                className={styles.SingleCommercialWeb}
                key={commercial.id}
                commercial={commercial}
                web
                selectedAppBrand={selectedAppBrand}
              />
            );
          })}

        {/* Empty State - Clean and Simple */}
        {webCommercials.length === 0 &&
          !loadingWebCommercials &&
          selectedAppBrand && (
            <div className={styles.EmptyState}>
              <div className={styles.EmptyStateTitle}>
                No Web Advertisements
              </div>
              <div className={styles.EmptyStateMessage}>
                No web advertisements found for{" "}
                <strong>{selectedAppBrand.name}</strong>.
              </div>
            </div>
          )}

        {/* Loading State */}
        {loadingWebCommercials && (
          <div className={styles.LoadingState}>
            Loading web advertisements...
          </div>
        )}
      </div>

      {newAdvModalVisible && (
        <NewCommercial
          web
          show={newAdvModalVisible}
          closeNewCommercialModal={closeNewCommercialModal}
          selectedAppBrand={selectedAppBrand}
        />
      )}

      {notificationMessageVisible && (
        <NotificationMessage
          onClick={() => setNotificationMessageVisible(false)}
        >
          Uspešno ste dodali reklamu!
        </NotificationMessage>
      )}
      {updateNotificationMessageVisible && (
        <NotificationMessage
          onClick={() => setUpdateNotificationMessageVisible(false)}
        >
          Uspešno ste ažurirali reklamu!
        </NotificationMessage>
      )}
    </>
  );
};

export default WebCommercials;
